<template lang="pug">
  section
    transition( name="description" )
      .container.purpose
        .description
          p.en Describe your Goal for this year
          p.jp 今年の目標を書いてください

        input(
          v-model="purpose",
          placeholder="input",
          maxlength="32"
        )

        .menu
          .btn( :class="{ disable:isDisable }", @click="onFix" ) 
            p OK
</template>

<script>
export default {
  data() {
    return {
      purpose: ""
    };
  },

  computed: {
    isDisable() {
      if (this.purpose.length > 0) return false;
      else return true;
    }
  },

  methods: {
    onFix() {
      if (this.purpose.length > 0) {
        this.$emit("onFix", this.purpose);
      }
    }
  }
};
</script>

<style scoped lang="scss">
</style>
